import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import React, { useState } from "react";
import { getWebService } from "../../helpers/server";
import { StyledTableCell, StyledTableRow, useStyles } from "../claims/styles";
// import "./plainFinder.css";

const PlanFinderDetails = ({ count = 0, list }) => {
  // 865159071313611
  const [search, setSearch] = useState();
  const [data, setData] = useState([]);
  const dataMap = {
    Name: data[0]?.product_name,
    "IEMI Number": data[0]?.start_date,
    "Invoice Amount": data[0]?.end_date,
    "Start Date": data[0]?.imei_number,
    "Mobile Number": data[0]?.name,
    "Payment Mode": data[0]?.mobile,
    "Phone Model": "",
  };
  const tableHeader = [
    "Plan Name",
    "Start Date",
    "End Date",
    "IEMI 1",
    "Name",
    "Mobile",
    "Claims",
  ];
  const handleChange = (e) => {
    const { value } = e.target;
    if (value.length === 15 || value.length === 10) {
      setSearch(value);
    }
  };
  const onSearchClickHandler = () => {
    if (search) {
      fetchData();
    }
  };
  const fetchData = async () => {
    try {
      const response = await getWebService(`v2/orders?search_plan=${search}`);
      setData(response.data.data.policies);
    } catch (err) {}
  };

  return (
    <Grid style={{ padding: "4rem" }}>
      <Box
        style={{
          marginBottom: "1rem",
          width: "50%",
          display: "flex",
          alignItems: "center",
          borderRadius: "12px",
        }}
      >
        <input
          style={{
            width: "100%",
            backgroundColor: "#fff",
            borderRadius: "12px",
            padding: "8px 16px",
            borderWidth: "0",
            height: "3rem",
            outline: "none",
            border: "none",
          }}
          name="search"
          placeholder="Search by iemi number or mobile number"
          onChange={handleChange}
        />
        <Box
          style={{
            backgroundColor: "#3c63fc",
            color: "#fff",
            padding: "8px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={onSearchClickHandler}
        >
          <Search />
        </Box>
      </Box>
      {data?.length > 0 && (
        <TableContainer component={Paper} className={useStyles.tableContainer}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {tableHeader.map((cur, id) => (
                  <StyledTableCell className={useStyles.inline} key={id}>
                    {cur}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody className={useStyles.tableBody}>
              {data?.length > 0 &&
                data?.map((cur, id) => {
                  return (
                    <StyledTableRow name="row">
                      <StyledTableCell
                        className={`${useStyles.td} ${useStyles.inLine}`}
                        key={id}
                      >
                        {cur?.product_name}
                      </StyledTableCell>
                      <StyledTableCell
                        className={`${useStyles.td} ${useStyles.inLine}`}
                        key={id}
                      >
                        {cur?.start_date}
                      </StyledTableCell>
                      <StyledTableCell
                        className={`${useStyles.td} ${useStyles.inLine}`}
                        key={id}
                      >
                        {cur?.end_date}
                      </StyledTableCell>
                      <StyledTableCell
                        className={`${useStyles.td} ${useStyles.inLine}`}
                        key={id}
                      >
                        {cur?.imei_number}
                      </StyledTableCell>
                      <StyledTableCell
                        className={`${useStyles.td} ${useStyles.inLine}`}
                        key={id}
                      >
                        {cur?.name}
                      </StyledTableCell>
                      <StyledTableCell
                        className={`${useStyles.td} ${useStyles.inLine}`}
                        key={id}
                      >
                        {cur?.mobile}
                      </StyledTableCell>
                      <StyledTableCell
                        className={`${useStyles.td} ${useStyles.inLine}`}
                        key={id}
                      >
                        {/* {cur?.name} */}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};

export default PlanFinderDetails;
